import { createActionTypes } from "@helpers/redux-helpers";

export const signUpActionTypes = createActionTypes("signup");
export const signUpModalType = "sign-up-modal";
